// 9fbef606107a605d69c0edbcd8029e5d
import dynamic from 'next/dynamic';
import AddressBook from '../AddressBook/container/AddressBook.container';
import AccountOverview from '../AccountOverview/container/AccountOverview.container';
import AddEditAddress from '../AddEditAddress/container/AddEditAddress.container';
import Payment from '../Payment/container/Payment.container';
import { MyPrefrenceContainer } from '../MyPrefrence/container/MyPreference.container';
import AddEditCreditCardContainer from '../AddEditCreditCard/container/AddEditCreditCard.container';
import MailingInformationContainer from '../MyProfile/organism/MailingInformation';
import AddGiftCardContainer from '../Payment/AddGiftCard/container/AddGiftCard.container'; //eslint-disable-line
import PlaceRewards from '../PlaceRewards/container/PlaceRewards.container';
import Wallet from '../Wallet/container/Wallet.container';
import MyProfile from '../MyProfile/container/MyProfile.container';
import ChangePassword from '../ChangePassword';
import AddEditPersonalInformationContainer from '../AddEditPersonalInformation';
import AboutYouInformationContainer from '../AboutYouInformation';
import BirthdaySavingsPage from '../BirthdaySavingsPage';
import PointHistoryPage from '../PointHistory';
import EarnPoints from '../ExtraPoints';
import PointsClaimPage from '../PointsClaim';
import Orders from '../Orders';
import FavoritesContainer from '../../browse/Favorites/container/Favorites.container';
import OrderDetails from '../OrderDetails';
import MyPlaceRewardsCreditCardContainer from '../MyPlaceRewardsCreditCard';

const PlacePerksContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "PlacePerks" */ '@tcp/core/src/components/features/account/PlacePerks'
  )
);

const RatingReview = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "RateAndReview" */ '../RatingReview'
  )
);

const BuyItAgainContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "BuyItAgain" */ '@tcp/core/src/components/features/account/BuyItAgain'
  )
);

const AccountComponentMapping = {
  'address-book': AddressBook,
  'account-overview': AccountOverview,
  'add-new-address': AddEditAddress,
  'edit-address': AddEditAddress,
  'add-gift-card': AddGiftCardContainer,
  payment: Payment,
  'add-credit-card': AddEditCreditCardContainer,
  'edit-credit-card': AddEditCreditCardContainer,
  'place-rewards': PlaceRewards,
  wallet: Wallet,
  profile: MyProfile,
  'change-password': ChangePassword,
  'edit-personal-info': AddEditPersonalInformationContainer,
  'birthday-savings': BirthdaySavingsPage,
  'edit-mailing-address': MailingInformationContainer,
  'edit-aboutyou-info': AboutYouInformationContainer,
  'my-preference': MyPrefrenceContainer,
  'points-history': PointHistoryPage,
  'extra-points': EarnPoints,
  'points-claim': PointsClaimPage,
  orders: Orders,
  favorites: FavoritesContainer,
  'order-details': OrderDetails,
  rewardsCreditCard: MyPlaceRewardsCreditCardContainer,
  'buy-it-again': BuyItAgainContainer,
  'rate-review': RatingReview,
  'place-perks': PlacePerksContainer,
};

export default AccountComponentMapping;
